import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { BLOG } from "@/data/catalog";

export default function Blog() {
  const [feat, ...rest] = BLOG;
  return (
    <div data-testid="blog-page">
      <PageHeader overline="Insights" title="The ElitzPacks journal." subtitle="Packaging tips, eco guides, shipping know-how and branding ideas to help your business package smarter." />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <Reveal>
          <Link to={`/blog/${feat.slug}`} data-testid={`blog-feat-${feat.slug}`} className="group grid lg:grid-cols-2 gap-8 rounded-4xl border border-border bg-card overflow-hidden hover:shadow-2xl hover:shadow-royal/5 transition-shadow">
            <div className="overflow-hidden aspect-[16/10] lg:aspect-auto"><img src={feat.image} alt={feat.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <span className="overline text-royal">{feat.cat} · {feat.read}</span>
              <h2 className="mt-4 font-heading text-3xl lg:text-4xl font-extrabold text-foreground group-hover:text-royal transition-colors">{feat.title}</h2>
              <p className="mt-4 text-muted-foreground leading-relaxed">{feat.excerpt}</p>
              <span className="mt-6 inline-flex items-center gap-2 font-semibold text-royal">Read article <ArrowUpRight size={18} /></span>
            </div>
          </Link>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((b, i) => (
            <Reveal key={b.slug} delay={(i % 3) * 0.06}>
              <Link to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="group block rounded-4xl border border-border bg-card overflow-hidden hover:-translate-y-1 transition-transform">
                <div className="overflow-hidden aspect-[16/10]"><img src={b.image} alt={b.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
                <div className="p-6">
                  <span className="overline text-royal">{b.cat} · {b.read}</span>
                  <h3 className="mt-3 font-heading text-xl font-bold text-foreground group-hover:text-royal transition-colors">{b.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{b.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
